export const TSFR_MAX_LENGTH = 12 as number;
export const VALID_CHARS_REGEX = /^\d+$/;
export const TSFR_SPLIT_CHECKDIGIT_LENGTH = 10 as number;
